import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import PublicPositionList from "./PublicPositionList";

export default {
  list: PublicPositionList,
  icon: AccountBalanceIcon,
};
